import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveProductUrl from '../../../utils/urls/resolve-product-url';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";
import Thumbnail from '../../thumbnail';

const LocalfirmProducts = ({ active }) => {
  const { category, products } = useStaticQuery(graphql`
    query LocalfirmProducts {
      category: mysqlTerms(cluster: {eq: "localfirms_5"}) {
        term_normalized
        path
      }

      products: allMysqlLocalfirms(
        filter: {type: {eq: 5}, isHeadquarters: {eq: 1}},
        limit: 9
      ) {
        nodes {
          mysqlId
          name
          prefix_url
          url
          mysqlImage {
            childImageSharp {
              gatsbyImageData(width: 55,  outputPixelDensities: [1, 2])
            }
          }
        }
      }
    }
  `);

  if (!products.nodes.length || !category) {
    return null;
  }

  return (<>
    <strong>Oferty pośredników kredytowych</strong>

    <div className={['top-navigation-products-square', b.mt2, b.pt1].join(' ')}>
      {products.nodes.map((product, i) => (
        <Link key={i} to={resolveProductUrl(product)}>
          {active && <div className="top-navigation-logo-wrapper">
            <Thumbnail image={product.mysqlImage} alt="" />
          </div>}

          <span>{product.name}</span>
        </Link>
      ))}
    </div>

    <Link className={[b.btn, "btn-light", "btn-cta", 'button-white', b.mt4].join(" ")} to={resolveUrl(category.path, category.term_normalized)}>
      {active && <Icon size={17} icon="Info" />}
      
      Informacje o pośrednikach kredytowych
    </Link>
  </>);
};

export default LocalfirmProducts;
